import { render, staticRenderFns } from "./send-message.vue?vue&type=template&id=3d349a58&scoped=true&"
import script from "./send-message.vue?vue&type=script&lang=js&"
export * from "./send-message.vue?vue&type=script&lang=js&"
import style0 from "./send-message.vue?vue&type=style&index=0&id=3d349a58&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d349a58",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VProgressCircular,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d349a58')) {
      api.createRecord('3d349a58', component.options)
    } else {
      api.reload('3d349a58', component.options)
    }
    module.hot.accept("./send-message.vue?vue&type=template&id=3d349a58&scoped=true&", function () {
      api.rerender('3d349a58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/aawz-intelligence-v2/components/send-message/send-message.vue"
export default component.exports